import { render, staticRenderFns } from "./PlantSelect.vue?vue&type=template&id=46a3283b&scoped=true&"
import script from "./PlantSelect.vue?vue&type=script&lang=ts&"
export * from "./PlantSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a3283b",
  null
  
)

export default component.exports